const timezones = [
  { offset: "GMT-10:00", name: "America/Adak" },
  { offset: "GMT-09:00", name: "America/Anchorage" },
  { offset: "GMT-08:00", name: "America/Los_Angeles" },
  { offset: "GMT-07:00", name: "America/Denver" },
  { offset: "GMT-06:00", name: "America/Chicago" },
  { offset: "GMT-05:00", name: "America/New_York" },
];

export default timezones;